import React from 'react'
import { Outlet } from 'react-router-dom'

function CustomerSupport() {
  return (
   <Outlet/>
  )
}

export default CustomerSupport